import React, { useContext } from 'react';
import { AuthContext } from 'components/user/AuthContext';
import HeaderSignedOut from './HeaderSignedOut';
import HeaderSignedIn from './HeaderSignedIn';

const Header = () => {
  const { isLoggedIn, handleLogout, isLoading } = useContext(AuthContext);

  return (
    <div className="w-full">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
        <a href="/" className="flex items-center">
          <img src="/logo.svg" alt="Twutter Logo" className="w-8 h-8 invert brightness-0 contrast-100" />
          <h1 className="ml-2 text-xl font-bold flex items-center">Twutter</h1>
        </a>

        <div className="flex-1 flex justify-end items-center">
          {!isLoading && (
            isLoggedIn ? (
              <HeaderSignedIn onLogout={handleLogout} />
            ) : (
              <HeaderSignedOut />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
